import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { SupportTicketService } from '../../Model/Support/support-ticket.service';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { SessionService } from '../../Util/Session/session.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { ViewDocumentDetailComponent } from '../view-document-detail/view-document-detail.component';

@Component({
  selector: 'app-view-uniform-detail',
  standalone: true,
  imports: [NgbModule, FormsModule, NgSelectModule, CommonModule, LoaderComponent, DataTablesModule],
  templateUrl: './view-uniform-detail.component.html',
  styleUrl: './view-uniform-detail.component.scss'
})
export class ViewUniformDetailComponent {
  isDisabled: boolean = false;
  @Input() InputData: any;
  public User: any = null;

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  dtTrigger: Subject<any> = new Subject<any>();
  UniformDetails: any[] = []
  ExcelReport: any[] = []
  dtoptions: DataTables.Settings = {};
  constructor(public activeModal: NgbActiveModal,
    private toast: ToastService,
    private support: SupportTicketService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private sessionService: SessionService,
    private utility: UtilityService,
    private download: DownloadSampleService,
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    this.getData();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  getData() {
    this.isDisabled = true;
    this.support.ESS_Uniform({ SelectType: '1', EmpMasterId: this.InputData.EmpMasterId, DocumentNo: '' }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.UniformDetails = Object.values(response.Table);
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
        return true
      },
      error: (err) => {
        this.isDisabled = false;
        return false;
      }
    })
  }

  Cancel() {
    this.activeModal.close();
  }

  Excel() {
    this.isDisabled = true;
    this.support.ESS_Uniform({ SelectType: '3', EmpMasterId: this.InputData.EmpMasterId, DocumentNo: '' }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.ExcelReport = Object.values(response.Table);
          if (this.ExcelReport.length > 0) {
            this.download.exportToExcel(this.ExcelReport, "UniformsDetails_data");
            this.isDisabled = false
          }
          else {
            this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
            this.isDisabled = false
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
        return true
      },
      error: (err) => {
        this.isDisabled = false;
        return false;
      }
    })
  }

   ViewDocument(element: any) {
      const modalRef = this.modalService.open(ViewDocumentDetailComponent, { centered: true, backdrop: 'static', size: 'xl' });
      modalRef.componentInstance.InputData = {
        EmpMasterId: this.InputData.EmpMasterId,
        EmpName: this.InputData.EmpName,
        EmpCode: this.InputData.EmpCode,
        DocumentNo: element.DocumentNo,
        DesignationName: this.InputData.DesignationName,
        Photo: this.InputData.Photo,
      };
      modalRef.result.then((result) => {
        if (result) {
        }
      }).catch((reason) => {
        console.log('Modal dismissed:', reason);
      });
    }
}
